import { Editor, Element, Node, Text } from 'slate';

export interface NodeFilterOption {
  type?: string;
  matchFn?: (node: Node) => boolean;
}

export const getMatchCondition = (options: NodeFilterOption) => {
  if (options?.type) {
    return { match: (n: any) => n.type === options?.type };
  }

  if (options?.matchFn) {
    return { match: options.matchFn };
  }
  return {};
};

export const isNotInlineElement = (editor: Editor) => (node) =>
  node && Element.isElement(node) && !editor.isInline(node);

export const isInlineElement = (editor: Editor) => (node) =>
  node && Element.isElement(node) && editor.isInline(node);

export const isElementWithType = (node: Node, type: string) =>
  node && Element.isElement(node) && (node as any).type === type;

export const isElementNotWithType = (node: Node, type: string) =>
  node && Element.isElement(node) && (node as any).type !== type;

export const isEmptyTextNode = (node: Node) => {
  return Text.isText(node) && node.text.trim() === '';
};
